import reducer, { initState } from './residentForm.reducers';
import * as actions from './residentForm.actions';
import watch from './residentForm.operations';

export { initState, actions, watch };

export default reducer;
